export const selectTypeBetIndirect = [
  { id: 1, value: '', label: 'GH76JK' },
  { id: 2, value: 'GH76JKK', label: 'GH76JKK' },
  { id: 3, value: 'GH76JKL', label: 'GH76JKL' }
]
